var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlocalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.599609C5.87904 0.602112 3.84566 1.44577 2.34592 2.94552C0.846168 4.44526 0.00251067 6.47864 8.51118e-06 8.5996C-0.00253177 10.3329 0.56363 12.0191 1.61164 13.3996C1.61164 13.3996 1.82982 13.6869 1.86546 13.7283L8 20.9632L14.1374 13.7247C14.1694 13.6861 14.3884 13.3996 14.3884 13.3996L14.3891 13.3974C15.4366 12.0175 16.0025 10.3321 16 8.5996C15.9975 6.47864 15.1538 4.44526 13.6541 2.94552C12.1543 1.44577 10.121 0.602112 8 0.599609V0.599609ZM8 11.5087C7.42464 11.5087 6.86219 11.3381 6.3838 11.0184C5.9054 10.6988 5.53254 10.2444 5.31235 9.71286C5.09217 9.18129 5.03456 8.59637 5.14681 8.03207C5.25906 7.46776 5.53612 6.94941 5.94296 6.54257C6.34981 6.13572 6.86816 5.85866 7.43247 5.74641C7.99677 5.63416 8.58169 5.69177 9.11326 5.91195C9.64483 6.13214 10.0992 6.505 10.4188 6.9834C10.7385 7.4618 10.9091 8.02424 10.9091 8.5996C10.9081 9.37084 10.6013 10.1102 10.056 10.6556C9.51062 11.2009 8.77124 11.5077 8 11.5087V11.5087Z",
    fill: "url(#paint0_linear_13552_6577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13552_6577",
    x1: 9.53455,
    y1: -7.83797,
    x2: -10.545,
    y2: 1.57454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B83AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlocalicon);
export default __webpack_public_path__ + "static/media/hyperlocalicon.39c85aba.svg";
export { ForwardRef as ReactComponent };